var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('compMutiUpload',_vm._b({on:{"on-cancel":function($event){return _vm.$emit('on-close')}}},'compMutiUpload',_vm.propsData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }